import React, { useEffect, useState } from "react";
import { Button } from "../../components/_helpers/components/Button";
import { useNavigate } from "react-router-dom";
import { firstLetterCapital, singular, plural } from "../_helpers/functions";
import { Search } from "../Layout/Private/Search";

export const Table = (props) => {
    const navigate = useNavigate();
    const [expandedRows, setExpandedRows] = useState([]);

    const {
        headers,
        rows,
        onClick,
        name,
        addNavigate,
        hideTitle,
        searchable,
        searchAction,
        searchData,
        isVisible,
        buttonName,
        renderSubTable, // <-- Fonction facultative pour afficher le sous-tableau
    } = props;

    const toggleRow = (id) => {
        setExpandedRows((prev) =>
            prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
        );
    };

    const isDarkText = (color) => {
        const r = Number("0x" + color.substring(1, 3));
        const g = Number("0x" + color.substring(3, 5));
        const b = Number("0x" + color.substring(5, 7));
        return 0.3 * r + 0.59 * g + 0.11 * b >= 128;
    };


    return (
        <div className="flex flex-col w-full">
            <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div className="inline-block min-w-full py-2 pt-0 sm:px-6 lg:px-8">
                    <div className="overflow-hidden">
                        {!hideTitle && (
                            <div
                                className="flex justify-between mt-3"
                                key={name}
                            >
                                {name && (
                                    <h5 className="text-xl font-semibold text-gray-700 mb-2">
                                        {plural(name)}
                                    </h5>
                                )}

                                {(addNavigate || searchable) && (
                                    <div className="flex gap-2">
                                        {searchable && (
                                            <Search
                                                items={searchData}
                                                handleClick={searchAction}
                                                placeholder="Trouver un utilisateur"
                                            />
                                        )}
                                        {addNavigate && isVisible && (
                                            <Button
                                                type="empty"
                                                action={() =>
                                                    navigate(addNavigate)
                                                }
                                                name={
                                                    buttonName
                                                        ? buttonName
                                                        : "+"
                                                }
                                            />
                                        )}
                                    </div>
                                )}
                            </div>
                        )}
                        <table className="min-w-full text-left text-sm font-light text-surface">
                            {headers && (
                                <thead className="border-b border-neutral-200 font-medium">
                                    <tr>
                                        {headers.map((element) => (
                                            <th
                                                key={element}
                                                className="px-6 py-2 text-app-primary"
                                            >
                                                {element}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                            )}
                            <tbody>
                                {rows.map((elements, rowIndex) => {
                                    const rowData = elements["row"];
                                    const data = elements["data"];
                                    const rowBgColor =
                                        data.bg_color != null &&
                                            String(data.bg_color).trim() !== ""
                                            ? String(data.bg_color).trim()
                                            : null;
                                    const rowBgStyle = rowBgColor
                                        ? { backgroundColor: rowBgColor, opacity: "75%", color: isDarkText(rowBgColor) ? "#0d0d0d" : "#d0d0d0"}
                                        : undefined;

                                    const isExpanded = expandedRows.includes(
                                        data.id
                                    );

                                    const rowExtraClass = typeof data.rowClassName === "string" && data.rowClassName.trim() !== ""
                                        ? ` ${data.rowClassName}`
                                        : "";

                                    return (
                                        <React.Fragment
                                            key={data.id || rowIndex}
                                        >
                                            <tr
                                                onClick={() => {
                                                    if (onClick) onClick(data);
                                                    toggleRow(data.id);
                                                }}
                                                className={`border-b border-neutral-200 cursor-pointer transition-colors duration-150 ease-out hover:bg-[color-mix(in_srgb,var(--color-app-secondary)_78%,var(--color-app-primary)_22%)]${rowExtraClass}`}
                                            >
                                                {rowData.map(
                                                    (el, cellIndex) => (
                                                        <td
                                                            key={cellIndex}
                                                            className="whitespace-nowrap px-6 py-2"
                                                        >
                                                            <span
                                                                className="p-1.5 rounded-xl"
                                                                style={
                                                                    cellIndex === 0
                                                                        ? rowBgStyle
                                                                        : undefined
                                                                }>
                                                                {el !== null
                                                                    ? el
                                                                    : "Non renseigné"}
                                                            </span>
                                                        </td>
                                                    )
                                                )}
                                            </tr>

                                            {/* Sous-tableau (affiché si la ligne est "ouverte") */}
                                            {isExpanded && renderSubTable && (
                                                <tr>
                                                    <td
                                                        colSpan={headers.length}
                                                        className="bg-gray-100 px-6 py-4"
                                                    >
                                                        {renderSubTable(data)}
                                                    </td>
                                                </tr>
                                            )}
                                        </React.Fragment>
                                    );
                                })}
                                {rows.length === 0 && (
                                    <tr className="border-b border-neutral-200 transition-colors duration-150 ease-out hover:bg-[color-mix(in_srgb,var(--color-app-secondary)_78%,var(--color-app-primary)_22%)]">
                                        <td
                                            colSpan={
                                                headers ? headers.length : 1
                                            }
                                            className="text-center"
                                        >
                                            Aucun(e){" "}
                                            {name ? singular(name) : "élément "}{" "}
                                            n'a été ajouté(e).
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};
